import ActionTypes from "../../../constants";
import { BusinessPartnerType } from "../../BusinessPartnerDetails/types";
import { SearchPayloadType, PaginationInfoType } from "../types";

export interface SearchBPActionType {
  type: typeof ActionTypes.SEARCH_BP;
  payload: SearchPayloadType;
}
export const searchBP = (payload: SearchPayloadType): SearchBPActionType => ({
  type: ActionTypes.SEARCH_BP,
  payload
});


export interface SearchBPSucceededActionType {
  type: typeof ActionTypes.SEARCH_BP_SUCCEEDED;
  businessPartnerLists: BusinessPartnerType[];
  paginationInfo: PaginationInfoType;
  // searchQuery: string;
}
export const searchBPSucceeded = (businessPartnerLists: BusinessPartnerType[], paginationInfo: PaginationInfoType): SearchBPSucceededActionType => ({
  type: ActionTypes.SEARCH_BP_SUCCEEDED,
  businessPartnerLists,
  paginationInfo,
});

export interface ResetSearchBPSucceededFlagActionType {
  type: typeof ActionTypes.RESET_SEARCH_BP_SUCCEEDED_FLAG
}
export const resetSearchBPSucceededFlag = (): ResetSearchBPSucceededFlagActionType => ({
  type: ActionTypes.RESET_SEARCH_BP_SUCCEEDED_FLAG
})
export interface ClearBPListsActionType {
  type: typeof ActionTypes.CLEAR_BP_LIST;
}
export const clearBPLists = () => ({
  type: ActionTypes.CLEAR_BP_LIST
});
